import PropTypes from "prop-types";
import React from "react";
import { Button } from "@mantine/core";
import { useStylesButton } from "../../utils/mantine/useStylesButton";
import FooterFormArrowSvg from "../../svg/FooterFormArrowSvg";
import IconStampFromFile from "../../svg/StampFromFile";
import IconVerifyFromFile from "../../svg/VerifyFromFile";
import IconStampContentId from "../../svg/StampContentId";
import { IconChevronRight } from "@tabler/icons-react";
import IconStampText from "../../svg/StampText";
import IconStampPortfolio from "../../svg/StampPortfolio";
const CustomButton = ({
  text,
  componentClasses,
  type = "submit",
  variant = "filled",
  onClick = "",
  loading = false,
  icon = "",
  id = "",
  disabled = false,
}) => {
  const { classes } = useStylesButton();
  const classList = componentClasses.split(" ");

  const combinedClasses = classList
    .map((className) => {
      return classes[className] || className;
    })
    .filter(Boolean);
  return (
    <Button
      className={combinedClasses.join(" ")}
      type={type}
      variant={variant}
      id={id}
      disabled={disabled}
      loading={loading}
      onClick={onClick || (() => {})}
    >
      {icon === "IconStampFromFile" && <IconStampFromFile />}
      {icon === "IconVerifyFromFile" && <IconVerifyFromFile />}
      {icon === "IconStampContentId" && <IconStampContentId />}
      {icon === "IconStampText" && <IconStampText />}
      {icon === "IconStampPortfolio" && <IconStampPortfolio />}

      {text}
      {icon === "footerFormSubmit" && <FooterFormArrowSvg />}
      {icon === "IconChevronRight" && <IconChevronRight />}
    </Button>
  );
};

CustomButton.propTypes = {
  text: PropTypes.string.isRequired,
  componentClasses: PropTypes.string,
  icon: PropTypes.string,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  variant: PropTypes.oneOf(["filled", "outline", "transparent"]),
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default CustomButton;
